import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import classnames from 'classnames';

interface Props {
  className?: string;
}

/**
 * The general-note alert (PROD-407) — states the full exclusivity rule so the customer understands
 * the model before applying anything. Rendered as an info alert label (ⓘ icon + bordered box).
 * Static copy only; carries no state.
 */
const DiscountGeneralNote: FC<Props> = ({ className }) => {
  const { t } = useTranslation(null, { keyPrefix: 'Features:DiscountExclusivity' });

  return (
    <div
      data-test="exclusivity-general-note"
      className={classnames(
        'flex items-start gap-xs rounded-lg border-xs border-brand-border bg-brand-background-secondary p-sm text-xs text-muted-foreground',
        className,
      )}
    >
      <Info className="w-4 h-4 shrink-0 mt-[1px]" />
      <span>{t('general_note')}</span>
    </div>
  );
};

export default DiscountGeneralNote;
